import React, { Component } from 'react';
import { Container } from 'reactstrap';
import AppNavbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

export default class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            email: '', 
            name: '', 
            seismic: 'UofT Seismic Design Team',
            msg: 'Shoot us a message',
            user_msg:''
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount(){ window.scrollTo(0, 0) }

    handleChange(event) {
        if(event.target.id === 'email'){
            this.setState({email: event.target.value});
        }else if(event.target.id === 'name'){
            this.setState({name: event.target.value});
        }else{
            this.setState({user_msg: event.target.value});
        }
    }
    
    handleSubmit (event) {

        if(this.state.email === "" || this.state.name === "" || !this.state.email.includes('@') || this.state.user_msg === ""){
            this.setState({msg: 'please enter valid information'});
        }else{
            const templateId = 'contact_msg';
            const serviceId = 'seismic_design_team';
            this.sendFeedback(serviceId, templateId, {message_html: this.state.user_msg, to_name: this.state.seismic, from_name: this.state.name, reply_to: this.state.email})
            this.setState({
                email: '',
                name: '',
                user_msg: '',
                msg: 'Thanks for your interest! 😊'
            })
        }
    }

    sendFeedback (serviceId, templateId, variables) {
        window.emailjs.send(
            serviceId, templateId,
            variables
            ).then(res => {
            console.log('Email successfully sent!')
            })
            // Handle errors here however you like, or use a React error boundary
            .catch(err => console.error('Oh well, you failed. Here some thoughts on the error that occured:', err))
    }

    render() {
        return <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            minHeight: '100vh' 
        }}>
        <AppNavbar/>
        <Container fluid className="col-lg-10 body-content" style={{ flex: 1 }}>
            <div className="big-font text-dark">
                Contact Us
            </div>
            <div className="container mt-5 mb-5">
                <div className="row">
                    <div className="col-md-8 text-center body-content">
                        <h3 className="text-center font-weight-bold">Sponsor our Team/General Inquiries</h3>
                        <p>
                            Our team is filled with bright and hardworking individuals who would greatly benefit from your contributions. They allow us to
                            learn, teach and achieve incredible accomplishments. You can find all our amazing sponsors (past and present) <Link to="/sponsors">here</Link>.
                            For anyone who wants to learn more, reach out to our email at <a href="mailto:ut.seismic@gmail.com">ut.seismic@gmail.com</a>.
                        </p>
                        {/* <a className="btn btn-success" href="https://drive.google.com/file/d/13EeeSLytOPuJXVIyu_v7r02Ww1ECx1Dq/view?usp=sharing">Sponsorship Package</a> */}
                    </div>
                </div>
            </div>         
        </Container>
        <Footer/>
    </div>;
    }
}